import PostPage from '../post_page';
import postPageStateManager from '../postpage_state_manager';
import withTracking from '../../../../../utils/tracking/components/withTracking';
import { pageView } from '../../../../../utils/tracking/events/pageEvents';

const mapTrackingToProps = trackEvent => ({
  trackPageView: pageObject => trackEvent(pageView(pageObject))
});

const trackedPostPage = withTracking(mapTrackingToProps)(PostPage);

export default function(store) {
  return {
    path: '/:id/:slug',
    component: trackedPostPage,
    exact: true,
    strict: true,
    loadData: postPageStateManager(store)
  };
}
